import { render, staticRenderFns } from "./UnacceptedProductProcessByCGB.vue?vue&type=template&id=2157c99e&scoped=true&"
import script from "./UnacceptedProductProcessByCGB.vue?vue&type=script&lang=js&"
export * from "./UnacceptedProductProcessByCGB.vue?vue&type=script&lang=js&"
import style0 from "./UnacceptedProductProcessByCGB.vue?vue&type=style&index=0&id=2157c99e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2157c99e",
  null
  
)

export default component.exports